import { useEffect } from "react";

const Hotjar = () => {
  useEffect(() => {
    const loadHotjar = () => {
      if (!window.hj) {
        (function(h, o, t, j, a, r) {
          h.hj = h.hj || function() {
            (h.hj.q = h.hj.q || []).push(arguments);
          };
          h._hjSettings = {
            hjid: 5078197,
            hjsv: 6
          };
          a = o.getElementsByTagName("head")[0];
          r = o.createElement("script");
          r.async = 1;
          r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
          a.appendChild(r);
        })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
      }

      window.removeEventListener("scroll", loadHotjar);
      window.removeEventListener("click", loadHotjar);
      window.removeEventListener("mousemove", loadHotjar);
    };

    // Load only after first interaction
    window.addEventListener("scroll", loadHotjar, { once: true });
    window.addEventListener("click", loadHotjar, { once: true });
    window.addEventListener("mousemove", loadHotjar, { once: true });

    return () => {
      window.removeEventListener("scroll", loadHotjar);
      window.removeEventListener("click", loadHotjar);
      window.removeEventListener("mousemove", loadHotjar);
    };
  }, []);

  return null;
};

export default Hotjar;